export const Storage = {
  EMAIL_FORGOT_PASSWORD: '@Equites:auth:email:forgot-password',
  EMAIL_REGISTER: '@Equites:auth:email:register',
  LANGUAGE: '@Equites:auth:language',
  TOKENS: '@Equites:auth:tokens',
};
